import React from "react";
var __jsx = React.createElement;
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";
var HowToPay = function HowToPay(_ref) {
  var onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var steps = [{
    img: "blue-1.svg",
    text: tShort("remaining/how_to_pay_step_1", {
      ns: "web_tracking"
    })
  }, {
    img: "blue-2.svg",
    text: tShort("remaining/how_to_pay_step_2", {
      ns: "web_tracking"
    })
  }, {
    img: "blue-3.svg",
    text: tShort("remaining/how_to_pay_step_3", {
      ns: "web_tracking"
    })
  }, {
    img: "blue-4.svg",
    text: tShort("remaining/how_to_pay_step_4", {
      ns: "web_tracking"
    })
  }, {
    img: "blue-5.svg",
    text: tShort("remaining/how_to_pay_step_5", {
      ns: "web_tracking"
    })
  }, {
    img: "blue-6.svg",
    text: tShort("remaining/how_to_pay_step_6", {
      ns: "web_tracking"
    })
  }];
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/Sadad-payment.svg",
    alt: "",
    className: "w-[132px] h-[75px] block mx-auto mb-1.5 mt-10 max-lg:mb-0 max-lg:mt-0"
  }), /*#__PURE__*/React.createElement("strong", {
    className: "text-2xl leading-8 text-[#484848] block mx-auto mb-6 text-center max-lg:text-xl max-lg:mb-10"
  }, tShort("remaining/how_to_pay_title", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("ul", {
    className: "w-4/5 mx-auto mb-6 relative max-lg:w-full before:content-[''] before:absolute before:w-[2px] before:h-[95%] before:border-r-2 before:border-dashed before:border-[#979797] before:top-2.5 rtl:before:right-[15px] ltr:before:left-[15px] max-lg:rtl:before:right-[10px] max-lg:ltr:before:left-[10px]"
  }, steps.map(function (step, i) {
    return /*#__PURE__*/React.createElement("li", {
      key: i,
      className: "flex items-center mb-4 relative z-[2] last:mb-0 max-lg:mb-[25px]"
    }, /*#__PURE__*/React.createElement("img", {
      src: CDN_LINK + "/assets/images/".concat(step.img),
      alt: "",
      className: "max-lg:w-[22px] max-lg:h-[32px]"
    }), /*#__PURE__*/React.createElement("strong", {
      className: "text-lg leading-6 text-[#484848] rtl:mr-[17px] ltr:ml-[17px] max-lg:text-base rtl:max-lg:mr-6"
    }, step.text));
  })), /*#__PURE__*/React.createElement("button", {
    className: "m-hide w-[132px] h-12 flex justify-center items-center cursor-pointer border-none rounded bg-[#f1f6fc] mx-auto text-base leading-6 text-[#6c7a8d] font-bold mb-8",
    onClick: onClose
  }, tShort("remaining/close", {
    ns: "web_tracking"
  })));
};
export default HowToPay;